export const OPERATION_ACTION_LABELS = Object.freeze({
  create_relation: "Müşteri İlişkisi Ekle",
  close_relation: "Müşteri İlişkisini Kapat",
  delete_relation: "Müşteri İlişkisini Sil",
  update_relation: "Müşteri İlişkisini Güncelle",
  update_selected_start: "İlişki Başlangıcını Güncelle",
  set_current_owner: "Fatura Sahibini Güncelle",
  create_product: "Ürün Ekle",
  close_product: "Ürünü Kapat",
  delete_product: "Ürünü Sil",
  update_product: "Ürünü Güncelle",
  update_tax_number: "VKN / TCKN Güncelle",
  update_billing_profile: "Fatura Profilini Güncelle",
  update_authorized_user: "Yetkili Kişi Ata",
});

export const OPERATION_ACTION_STATUS_LABELS = Object.freeze({
  safe: "Güvenli",
  blocked: "Engelli",
  warning: "Kontrol",
  applied: "Uygulandı",
});

export function formatOperationActionType(type, fallback = "-") {
  if (!type) {
    return fallback;
  }

  return OPERATION_ACTION_LABELS[type] || type;
}

export function formatOperationActionStatus(status, fallback = "Kontrol") {
  if (!status) {
    return fallback;
  }

  return OPERATION_ACTION_STATUS_LABELS[status] || status;
}

export function formatOperationActionText(text, fallback = "-") {
  if (!text) {
    return fallback;
  }

  return [
    [/ icin /g, " için "],
    [/ guncel /g, " güncel "],
    [/ Secilen /g, " Seçilen "],
    [/ secilen /g, " seçilen "],
    [/ kisi /g, " kişi "],
    [/ iliskisi /g, " ilişkisi "],
    [/ iliski /g, " ilişki "],
    [/ iliskide /g, " ilişkide "],
    [/ baslangicli /g, " başlangıçlı "],
    [/ baslangici /g, " başlangıcı "],
    [/ baslangic /g, " başlangıç "],
    [/ bitis /g, " bitiş "],
    [/ faturali /g, " faturalı "],
    [/ faturaya bagli /g, " faturaya bağlı "],
    [/ olmadigi /g, " olmadığı "],
    [/ oldugu /g, " olduğu "],
    [/ olusturulacak/g, " oluşturulacak"],
    [/ yapilacak/g, " yapılacak"],
    [/ alinacak/g, " alınacak"],
    [/ kapatilacak/g, " kapatılacak"],
    [/ urunu /g, " ürünü "],
    [/^Secilen /g, "Seçilen "],
    [/^Guncel /g, "Güncel "],
  ].reduce((value, [pattern, replacement]) => {
    return value.replace(pattern, replacement);
  }, String(text));
}
